module.exports = __webpack_public_path__ + "static/media/eco.7f06ebca.png";